import gql from 'graphql-tag';

export const Good360PatchMutation = gql`
	mutation Good360PatchMutation($id: ID!, $changes: Good360PatchInput!) {
		results: good360Patch(id: $id, changes: $changes) {
			id
			description
			editorialDescription
			relatedSameCategory
			relatedSameTrend
			relatedSameClaim
			relatedSameCompany
			relatedMax
		}
	}
`;